import React from 'react';
import {Link} from 'react-router-dom';
import PageContainer from './PageContainer';
import styles from './AgentCentreMoved.scss';

function AgentCentreMoved(props) {
  return (
    <PageContainer>
      <div className={"container " + styles.containerNarrow}>
        <div className="text-center mt-5 mb-5"><img className={styles.hero} src="/assets/images/agency/agent-centre-moved.svg" /></div>
        <h1 className="mt-4">Agent Centre has moved</h1>
        <p>The <Link to="/">OnTheHouse.com.au</Link> Agent Centre is undergoing some major renovations to provide agents with better tools and more advanced insights to help you grow your business.</p>
        <p>While we build the new and improved Agent Centre, the current Agent Centre for <Link to="/">OnTheHouse.com.au</Link> is no longer accessible. We apologise for any inconvenience caused during this interim period.</p>
        <p>If you need any assistance with managing your listings or agent/agency profiles, please <a href="/contact-us?agentContact" rel="nofollow">contact us</a> and we&apos;ll be more than happy to help.</p>
        <h2>Help share our new Agent Centre!</h2>
        <p>We would love your feedback on our Agent Centre and how we can provide more value to agents. If you’d like to be contacted to participate in any informal interviews or surveys, please register your interest using our <a href="/contact-us?agentContact" rel="nofollow">online enquiry form</a>.</p>
      </div>
    </PageContainer>
  );
}

export default AgentCentreMoved;
